export default {
  getCookie(cname){
    var name = cname + '=';
    var ca = document.cookie.split(';')
    for(var i = 0; i < ca.length;i++){
      var c = ca[i].trim();
      if(c.indexOf(name) == 0) return c.substring(name.length, c.length)
    }
    return ''
  },
  setCookie(cname,cvalue,exdays){
    var d = new Date();
    d.setTime(d.getTime()+(exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  },
  clearCookie: function() {
    this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
}
}


// WEBPACK FOOTER //
// ./src/util/util.js